import React from 'react';
import Pdf from 'assets/common/pdf.png';
import s from './s.module.less';
import { CloudDownloadOutlined } from '@ant-design/icons';

type Props = {
    src?: string;
};

const LicenseImg = (props: Props) => {
    const { src } = props;
    const unsupportedImgSrc = [
        '.pdf',
        '.CS',
        '.docx',
        '.mhtml',
        '.heic',
        '.html',
        '.xlsx',
        '.zip',
        '.icloud',
        '.doc',
        '.htm',
        '.prn',
        '.mp4',
    ];
    if (src?.toLocaleLowerCase().includes('.pdf')) {
        return (
            <div className={s.pdfWrap}>
                <img src={Pdf} alt="license in PDF" />
                <a href={src} target="_blank" rel="noopener noreferrer">View PDF</a>
            </div>
        );
    }
    const isUnsupportedImg = unsupportedImgSrc.find((item) => src?.toLocaleLowerCase().includes(item));
    if (isUnsupportedImg) {
        return (
            <div className={s.downWrap}>
                <CloudDownloadOutlined style={{ fontSize: '50px' }} />
                <a href={src} target="_blank" rel="noopener noreferrer">View Resource</a>
            </div>
        );
    }

    return (
        <img src={src} alt="license" />
    );
};

export default LicenseImg;
